// Class: starling.assets.ByteArrayFactory

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_assets_AssetFactory() {return require("./../../starling/assets/AssetFactory");}
function openfl_utils_ByteArray() {return $import(require("openfl/utils/ByteArray"));}

// Constructor

var ByteArrayFactory = function() {
	(starling_assets_AssetFactory().default).call(this);
	this.addExtensions(["bin"]);
	this.addMimeTypes(["application/octet-stream"]);
}

// Meta

ByteArrayFactory.__name__ = "starling.assets.ByteArrayFactory";
ByteArrayFactory.__isInterface__ = false;
ByteArrayFactory.__super__ = (starling_assets_AssetFactory().default);
ByteArrayFactory.prototype = $extend((starling_assets_AssetFactory().default).prototype, {
	canHandle: function(reference) {
		return ((reference.get_data()) instanceof (openfl_utils_ByteArray().default));
	},
	create: function(reference,helper,onComplete,onError) {
		var byteArray = reference.get_data();
		onComplete(reference.get_name(),byteArray);
	}
});
ByteArrayFactory.prototype.__class__ = ByteArrayFactory.prototype.constructor = $hxClasses["starling.assets.ByteArrayFactory"] = ByteArrayFactory;

// Init



// Statics




// Export

exports.default = ByteArrayFactory;